import { createSlice } from "@reduxjs/toolkit"

const states = {
  v1: {
    language: 'EN',
  }
}

const initialState = states.v1

export const languageMigration = {
  1: state => state.v1
}

export const languageSlice = createSlice({
  name: "lang",
  initialState,
  reducers: {
    changeLanguage: (state, action) => {
      state.language = action.payload
    },
  },
});

export const { changeLanguage } = languageSlice.actions;

export default languageSlice.reducer;